import { createContext } from 'react';

import { EntityState, PROVIDER_NAME } from 'context/entity/types';
import { createInitialStorageContextState } from 'context/storage/createInitialStorageContextState';
import { createStorageContextProvider } from 'context/storage/createStorageContextProvider';

import { createUseEntity } from 'hooks/higherOrder/createUseEntity';
import { createUseUpdateState } from 'hooks/higherOrder/createUseUpdateState';

import { Hotel } from 'proto/Hotel/Hotel';

const contextName = 'AccommodationContext';
const AccommodationContext = createContext<EntityState<Hotel['id'], Hotel>>(
    createInitialStorageContextState(contextName)
);
AccommodationContext.displayName = contextName;

const AccommodationProvider = createStorageContextProvider(
    AccommodationContext,
    PROVIDER_NAME
);

export const useAccommodation = createUseEntity(AccommodationContext);

export const useUpdateAccommodation =
    createUseUpdateState(AccommodationContext);

export const buildSingleAccommodationList = (
    hotel?: Hotel
): Record<Hotel['id'], Hotel> =>
    hotel?.id
        ? {
              [hotel.id]: hotel,
          }
        : {};

export default AccommodationProvider;
